import FRApi from './_frApi';

class FrReportConfigListAPI extends FRApi {
  constructor() {
    super();
  }
  controllerName = 'FrReportConfigLists';
}

export default new FrReportConfigListAPI();
